import { isValidObject, SuperDate } from '@razlet/utils';

export default class ShimpentTerminalOrder {
  id = null;
  status = null;
  comment = null;

  updatedAt = null;
  syncedAt = null;

  constructor (data = {}) {
    if (!isValidObject(data)) return;

    this.id = data.id ?? null;
    this.status = data.status ?? null;
    this.comment = data.comment ?? null;

    this.updatedAt = data.updatedAt
      ? new SuperDate(data.updatedAt)
      : null;
    this.syncedAt = data.updatedAt
      ? new SuperDate(data.syncedAt)
      : null;
  }

  get isCreated () {
    return this.id !== null;
  }
}
